import React from 'react';
import { Badge } from 'reactstrap';
import { useAuth } from '../../AuthContext';

const AccountDisplay = () => {
  const { getCurrentAccountKey, getAvailableAccounts } = useAuth();
  
  const currentAccountKey = getCurrentAccountKey();
  const availableAccounts = getAvailableAccounts();

  // Don't render if no account or only one account
  if (!currentAccountKey || availableAccounts.length <= 1) {
    return null;
  }

  return (
    <div className="d-flex align-items-center mr-2">
      <Badge color="soft-primary" pill className="px-3 py-2 fs--1 font-weight-medium" style={{ minWidth: '60px', textAlign: 'center', borderRadius: '50rem' }}>
        {currentAccountKey}
      </Badge>
    </div>
  );
};

export default AccountDisplay;
